import {
	BifrostBackendApi,
	BifrostBackendNestApi
} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
import { store } from "../store";
import { SET_RETROACTIVE_POINTS_ASSIGNMENT_PENDING_ORDER_ID } from "../store/mutation-types";

const AppUsersProvider = {
	registerUser({ idpToken, payload }) {
		const clientTraceIdFromStorage = localStorage.getItem("clientTraceId");
		const userData = {
			tenantId: appConfig.tenantId,
			clientTraceId: clientTraceIdFromStorage ? clientTraceIdFromStorage : "",
			...payload,
			orderNumber: store.getters.retroactivePointsAssignmentPendingOrderId
		};

		const useNestAppUsersEndpoint =
			store.getters.featureToggles &&
			store.getters.featureToggles.useNestAppUsersEndpoint;

		const Backend = useNestAppUsersEndpoint
			? BifrostBackendNestApi
			: BifrostBackendApi;

		return Backend.post("/app-users", userData, {
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	logOutUser(idpToken, tenantId = null) {
		const useNestAppUsersEndpoint =
			store.getters.featureToggles &&
			store.getters.featureToggles.useNestAppUsersEndpoint;

		const Backend = useNestAppUsersEndpoint
			? BifrostBackendNestApi
			: BifrostBackendApi;
		store.commit(SET_RETROACTIVE_POINTS_ASSIGNMENT_PENDING_ORDER_ID);
		return Backend.get("/app-users/logOut", {
			params: {
				tenantId: tenantId || appConfig.tenantId
			},
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	logOutUserAllDevices(idpToken, tenantId = null) {
		const useNestAppUsersEndpoint =
			store.getters.featureToggles &&
			store.getters.featureToggles.useNestAppUsersEndpoint;

		const Backend = useNestAppUsersEndpoint
			? BifrostBackendNestApi
			: BifrostBackendApi;

		return Backend.get("/app-users/logOutAllDevices", {
			params: {
				tenantId: tenantId || appConfig.tenantId
			},
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	update(id, data, idpToken, tenantId = null) {
		const useNestAppUsersEndpoint =
			store.getters.featureToggles &&
			store.getters.featureToggles.useNestAppUsersEndpoint;

		const Backend = useNestAppUsersEndpoint
			? BifrostBackendNestApi
			: BifrostBackendApi;

		return Backend.patch(`/app-users`, data, { // TODO: check if this was ever working
			params: {
				tenantId: tenantId || appConfig.tenantId
			},
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	updateAll(dataArray, idpToken) {
		return dataArray.forEach((user) => AppUsersProvider.update(user, idpToken));
	},
	find(id, idpToken) {
		const useNestAppUsersEndpoint =
			store.getters.featureToggles &&
			store.getters.featureToggles.useNestAppUsersEndpoint;

		const Backend = useNestAppUsersEndpoint
			? BifrostBackendNestApi
			: BifrostBackendApi;

		return Backend.get(`/app-users/${id}`, {
			params: {
				tenantId: appConfig.tenantId
			},
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	findAll(idpToken) {
		const useNestAppUsersEndpoint =
			store.getters.featureToggles &&
			store.getters.featureToggles.useNestAppUsersEndpoint;

		const Backend = useNestAppUsersEndpoint
			? BifrostBackendNestApi
			: BifrostBackendApi;

		return Backend.get("/app-users", {
			params: {
				tenantId: appConfig.tenantId
			},
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	getOrdersOfLastYear(idpToken, limit, deliveryMethods = []) {
		return BifrostBackendNestApi.get(`/orders/getUserOrders?limit=${limit}&deliveryMethods=${deliveryMethods}`, {
			params: {
				tenantId: appConfig.tenantId
			},
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	getLastOrder(idpToken) {
		return BifrostBackendNestApi.get(`/orders/last-order`, {
			params: {
				tenantId: appConfig.tenantId
			},
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	getTestUsers() {
		return BifrostBackendNestApi
			.get("/devSupport/_getAutoLoginUsers", {
				tenantId: appConfig.tenantId
			},
			{
				headers: {}
			});
	}
};

export default Object.freeze(AppUsersProvider);
